import { useLocation } from "react-router-dom";

// Material UI components
import { Box } from "@mui/material";
import { Timeline, TimelineSeparator, TimelineConnector, TimelineItem } from "@mui/lab";

// Custom components
import WorkHistoryItem from "../WorkHistoryItem";

// Types
import { TWorkHistoryProps } from "../PersonWorkHistory.types";

// Styles
import { useStyles } from "./WorkHistory.styles";
import { TFunctionsLabels } from "../../CompoundPill/CompoundPill";

const WorkHistory = ({ elements, maxHeight, shouldHighlightPosition }: TWorkHistoryProps): JSX.Element => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <Box position="relative">
            <Timeline
                classes={{ root: classes.timeLine }}
                position="left"
                style={{
                    maxHeight: maxHeight !== -1 ? maxHeight : "unset",
                    overflow: maxHeight !== -1 ? "auto" : "inherit",
                }}
            >
                <TimelineItem className={classes.missingOppositeContent}>
                    <TimelineSeparator>
                        <TimelineConnector className={classes.connector} />
                    </TimelineSeparator>
                </TimelineItem>
                {elements.map((workHistory) => {
                    const functions: TFunctionsLabels[] =
                        workHistory.work_history_role?.map((fn) => ({
                            id: fn.role_function_id,
                            label: fn.role_function_label,
                            name: fn.role_function_name,
                            weight: fn.weight,
                        })) ?? [];

                    const hierarchy: string | null =
                        workHistory.work_history_role?.[0]?.default_role_level_name_alt_2 ?? null;

                    return (
                        <WorkHistoryItem
                            key={workHistory.id}
                            to={workHistory.to}
                            from={workHistory.from}
                            company={(workHistory.company_name || workHistory.unlinked_company) ?? ""}
                            highlightPosition={{
                                shouldHighlightPosition: Boolean(shouldHighlightPosition),
                                hasCurrentPosition: Boolean(workHistory?._inner_hit),
                            }}
                            position={workHistory.work_position_name}
                            functions={functions}
                            hierarchy={hierarchy}
                        />
                    );
                })}
            </Timeline>
            <Box className={classes.gradient} />
        </Box>
    );
};

export default WorkHistory;
